import React, { useContext, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  useTheme,
} from "@mui/material";
import { useMutation } from "@apollo/client";
import { EDIT_POLE_IN_SET } from "../graphql/gqlPoleset";
import { SnackbarContext } from "../contexts/snackbarContext";
import { T } from "../components/T";

const EditPoleInSetModal = ({
  isOpen,
  close,
  setId,
  poleId,
  length,
  color,
}: {
  isOpen: boolean;
  close: () => void;
  setId: string;
  poleId: string;
  length: number;
  color: string;
}) => {
  const theme = useTheme();

  const [newLength, setLength] = useState(length.toString());
  const [newColor, setColor] = useState(color);
  const { openSuccessSnackbar, openErrorSnackbar } =
    useContext(SnackbarContext);

  const [editPoleInSet] = useMutation(EDIT_POLE_IN_SET, {
    onCompleted: () => {
      close();
      setLength(newLength);
      openSuccessSnackbar(<T str="Pole edited" />);
    },
    onError: (error) => {
      openErrorSnackbar(error.message || <T str="Something went wrong" />);
    },
  });

  const handleEditPoleInSet = () => {
    editPoleInSet({
      variables: {
        polesetId: setId,
        poleId,
        poleType: {
          length: Math.round(Number(newLength) * 100) / 100,
          color: newColor,
          radius: 0.06,
        },
      },
    });
  };

  return (
    <Dialog
      open={isOpen}
      onClose={close}
      PaperProps={{
        sx: {
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
        },
      }}
    >
      <DialogTitle>
        <T str="Edit pole" />
      </DialogTitle>
      <DialogContent>
        <TextField
          label={<T str="Length" />}
          value={newLength}
          onChange={(e) => {
            if (e.target.value === "") setLength("");
            else if (Number(e.target.value)) setLength(e.target.value);
            else if (Number(e.target.value) === 0) setLength(e.target.value);
          }}
          fullWidth
          color="secondary"
          required
          type="text"
          sx={{
            mb: 2,
            mt: 2,
          }}
        />
        <TextField
          label={<T str="Color" />}
          value={newColor}
          onChange={(e) => {
            setColor(e.target.value);
          }}
          fullWidth
          color="secondary"
          required
          type="color"
          sx={{
            mb: 2,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={close}>
          <T str="Cancel" />
        </Button>
        <Button
          onClick={handleEditPoleInSet}
          variant="contained"
          color="secondary"
          disabled={!length}
        >
          <T str="Edit" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditPoleInSetModal;
